import React from 'react';
import { MapPin, Phone, Mail, ArrowRight } from 'lucide-react';
import { Button } from "@/components/ui/button";
const NewHeroSection = () => {
  const scrollToFooterForm = () => {
    const footerForm = document.getElementById('footer-form');
    if (footerForm) {
      footerForm.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="min-h-screen bg-gradient-to-br from-black via-dark-200 to-black flex items-center relative overflow-hidden pt-20 md:pt-24 lg:pt-0">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_50%,rgba(179,2,7,0.1),transparent_70%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(179,2,7,0.05),transparent_50%)] bg-black"></div>
      
      <div className="container mx-auto px-6 md:px-8 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Portrait - Move to first position on mobile/tablet */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end animate-fade-in" style={{
          animationDelay: '0.3s'
        }}>
            <div className="relative">
              <div className="w-72 h-72 md:w-80 md:h-80 lg:w-[32rem] lg:h-[32rem] rounded-full bg-gradient-to-br from-brand/20 to-transparent p-1">
                <div className="w-full h-full rounded-full bg-dark-300 flex items-center justify-center overflow-hidden">
                  <img src="/lovable-uploads/fcf81f42-2979-4d0d-a3c8-b7bb4ae416de.png" alt="Mike Foto Portrait" className="w-full h-full object-cover rounded-full" />
                </div>
              </div>
              {/* Floating elements */}
              <div className="absolute -top-6 -right-6 w-8 h-8 bg-brand rounded-full animate-pulse"></div>
              <div className="absolute -bottom-6 -left-6 w-6 h-6 bg-brand/60 rounded-full animate-pulse" style={{
              animationDelay: '1s'
            }}></div>
            </div>
          </div>
          
          {/* Content */}
          <div className="order-2 lg:order-1 animate-fade-in-up">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight text-left">
              Ο Mike Foto στήνει online παρουσίες που φέρνουν αποτέλεσμα
              <span className="text-brand"></span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed text-left">
              Προσφέρει υπηρεσίες web design, ecommerce, funnels, διαφημίσεων και digital στρατηγικής με πρακτική προσέγγιση και απόλυτη εστίαση στο αποτέλεσμα.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3 mb-10">
              <div className="flex items-center space-x-3 text-gray-300 text-sm">
                <MapPin className="w-4 h-4 text-brand" />
                <span>Πλατεία Δημοκρατίας 5, Θεσσαλονίκη</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300 text-sm">
                <Phone className="w-4 h-4 text-brand" />
                <span>+30 698 690 4312</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300 text-sm">
                <Mail className="w-4 h-4 text-brand" />
                <span>michaelfoto.contact@gmail.com</span>
              </div>
            </div>
            
            <div className="flex justify-start">
              <Button onClick={scrollToFooterForm} size="lg" className="bg-brand hover:bg-brand-hover text-white font-bold px-6 py-4 text-base rounded-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl group">
                <span>Συμπλήρωσε τη φόρμα</span>
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default NewHeroSection;
